import { render, staticRenderFns } from "./activity-session-table.vue?vue&type=template&id=0f8bf336&scoped=true&"
import script from "./activity-session-table.ts?vue&type=script&lang=ts&"
export * from "./activity-session-table.ts?vue&type=script&lang=ts&"
import style0 from "./activity-session-table.scss?vue&type=style&index=0&id=0f8bf336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8bf336",
  null
  
)

export default component.exports